import React from 'react'
import { Router, Route, Redirect, Switch } from 'react-router-dom'
import { AdminLayout } from '../_components/Shared/Layout/AdminLayout'
import { history } from '../_helpers'
import { connect } from 'react-redux'

// import Home from '../containers/home'

// import { PrivateRoute } from '../_components'
import { LoginPage } from '../LoginPage'

import { AdminDashboard } from '../_components/Dashboard/AdminDashboard/AdminDashboard'

import Users from '../_components/Users/index'
import UserForm from '../_components/Users/Form'

import Personnels from '../_components/Personnels/index'

import Categories from '../_components/Categories/index'
import Brands from '../_components/Brands/index'

import Products from '../_components/Products/index'
import ProductForm from '../_components/Products/FullForm/Form'

import { Warehouses } from '../_components/Warehouses/index'
import { WhmTasks } from '../_components/Tasks/Whm/index'

import { SmTasks } from '../_components/Tasks/Sm/index'
import { ReserveTasks } from '../_components/Tasks/Reserve/index'
import { PmTasks } from '../_components/Tasks/Pm/index'
import { PrumTasks } from '../_components/Tasks/Prum/index'
import { IumTasks } from '../_components/Tasks/Ium/index'
import { CumTasks } from '../_components/Tasks/Cum/index'
import { ClumTasks } from '../_components/Tasks/Clum/index'

import { SIumTasks } from '../_components/Tasks/SIum/index'
import { SPrumTasks } from '../_components/Tasks/SPrum/index'
import { SCumTasks } from '../_components/Tasks/SCum/index'
import { SClumTasks } from '../_components/Tasks/SClum/index'

import Banks from '../_components/Settings/Banks'
import Provinces from '../_components/Settings/Provinces'
import Cities from '../_components/Settings/Cities'

import Clients from '../_components/Clients/index'
import Cargos from '../_components/Cargos/index'
import Drivers from '../_components/Drivers/index'

// import Tasks from '../_components/Tasks/index';
// import TaskForm from '../_components/Tasks/Form';

import Messages from '../_components/Messages/index'
import Units from '../_components/Units/index'

import Customers from '../_components/Customers/index'

export const PrivateRoute = ({ component: Component, user, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      user && user.token ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect
          to={{ pathname: '/login', state: { from: props.location } }}
        />
      )
    }
  />
)

export const OnlyAdminRoute = ({ component: Component, user, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      user && user.userType !== undefined && [0].includes(user.userType) ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const AdminRoute = ({ component: Component, user, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      user && user.userType !== undefined && [0, 1].includes(user.userType) ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const WarehouseAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user &&
      user.userType !== undefined &&
      [0, 1, 2, 3, 12, 13].includes(user.userType) ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const SaleManagerAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user && user.userType !== undefined && [0, 1].includes(user.userType) ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const SaleManagerAdminWarehouseAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user &&
      user.userType !== undefined &&
      [0, 1, 3].includes(user.userType) ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const ProductionManagerAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user && user.userType !== undefined && [0, 2].includes(user.userType) ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const ImpregnationUnitManagerAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user && user.userType !== undefined && [0, 4].includes(user.userType) ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const ImpregnationUnitShiftManagerAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user && user.userType !== undefined && [0, 5].includes(user.userType) ? (
        <AdminLayout hideMenu>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const PressUnitManagerAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user && user.userType !== undefined && [0, 6].includes(user.userType) ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const PressUnitShiftManagerAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user && user.userType !== undefined && [0, 7].includes(user.userType) ? (
        <AdminLayout hideMenu>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const CuttingUnitManagerAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user &&
      user.userType !== undefined &&
      [0, 8, 10].includes(user.userType) ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const CuttingUnitShiftManagerAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user && user.userType !== undefined && [0, 9].includes(user.userType) ? (
        <AdminLayout hideMenu>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const ClickUnitManagerAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user &&
      user.userType !== undefined &&
      [0, 8, 10].includes(user.userType) ? (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

export const ClickUnitShiftManagerAdminRoute = ({
  component: Component,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      user && user.userType !== undefined && [0, 11].includes(user.userType) ? (
        <AdminLayout hideMenu>
          <Component {...props} />
        </AdminLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

class App extends React.Component {
  render() {
    const { user } = this.props
    return (
      <Router history={history}>
        <Switch>
          <PrivateRoute user={user} exact path="/" component={AdminDashboard} />
          <PrivateRoute
            user={user}
            exact
            path="/admin"
            component={AdminDashboard}
          />

          <Route path="/login" exact component={LoginPage} />

          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/users"
            component={Users}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/users/new"
            component={UserForm}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/users/:id/edit"
            component={UserForm}
          />

          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Personnels"
            component={Personnels}
          />

          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Categories"
            component={Categories}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Brands"
            component={Brands}
          />

          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Products"
            component={Products}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Products/new"
            component={ProductForm}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Products/:id/edit"
            component={ProductForm}
          />

          <WarehouseAdminRoute
            user={user}
            exact
            path="/admin/Warehouses"
            component={Warehouses}
          />
          <WarehouseAdminRoute
            user={user}
            exact
            path="/admin/Tasks/Whm"
            component={WhmTasks}
          />

          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Customers"
            component={Customers}
          />

          <SaleManagerAdminWarehouseAdminRoute
            user={user}
            exact
            path="/admin/Tasks/Sm"
            component={SmTasks}
          />
          <SaleManagerAdminWarehouseAdminRoute
            user={user}
            exact
            path="/admin/Tasks/Reserve"
            component={ReserveTasks}
          />
          <ProductionManagerAdminRoute
            user={user}
            exact
            path="/admin/Tasks/Pm"
            component={PmTasks}
          />
          <ImpregnationUnitManagerAdminRoute
            user={user}
            exact
            path="/admin/Tasks/Ium"
            component={IumTasks}
          />
          <PressUnitManagerAdminRoute
            user={user}
            exact
            path="/admin/Tasks/Prum"
            component={PrumTasks}
          />
          <CuttingUnitManagerAdminRoute
            user={user}
            exact
            path="/admin/Tasks/Cum"
            component={CumTasks}
          />
          <ClickUnitManagerAdminRoute
            user={user}
            exact
            path="/admin/Tasks/Clum"
            component={ClumTasks}
          />

          <ImpregnationUnitShiftManagerAdminRoute
            user={user}
            exact
            path="/admin/Tasks/SIum"
            component={SIumTasks}
          />
          <PressUnitShiftManagerAdminRoute
            user={user}
            exact
            path="/admin/Tasks/SPrum"
            component={SPrumTasks}
          />
          <CuttingUnitShiftManagerAdminRoute
            user={user}
            exact
            path="/admin/Tasks/SCum"
            component={SCumTasks}
          />
          <ClickUnitShiftManagerAdminRoute
            user={user}
            exact
            path="/admin/Tasks/SClum"
            component={SClumTasks}
          />

          {/* <OnlyAdminRoute user={user} exact path="/admin/Tasks" component={Tasks} />
          <OnlyAdminRoute user={user} exact path="/admin/Tasks/new" component={TaskForm} />
          <OnlyAdminRoute user={user} exact path="/admin/Tasks/:taskType/:id/edit" component={TaskForm} /> */}

          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Messages"
            component={Messages}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Units"
            component={Units}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Provinces"
            component={Provinces}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Cities"
            component={Cities}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Banks"
            component={Banks}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Clients"
            component={Clients}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Cargos"
            component={Cargos}
          />
          <OnlyAdminRoute
            user={user}
            exact
            path="/admin/Drivers"
            component={Drivers}
          />
        </Switch>
      </Router>
    )
  }
}

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}

const connectedApp = connect(mapStateToProps)(App)
export { connectedApp as App }
